import { Typography } from '@euler/app/components/typography';
import { VoiceNotice } from '@euler/components/voice-input/functions/useVoiceTurn';
import { kVoiceNoticeText } from '@euler/components/voice-input/functions/voiceNoticeText';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';

/**
 * Why the trainee's words did not get through, above the controls; the
 * words themselves show in the thread, as a draft bubble.
 */
export const VoiceNoticeLine = memo(
  ({ notice }: { notice: Exclude<VoiceNotice, null> }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ minHeight: rpx(22), paddingHorizontal: rpx(16) }}>
        <Typography.Text
          size={rpx(14)}
          color={aiColors.mutedForeground}
          style={{ textAlign: 'center' }}
        >
          {kVoiceNoticeText[notice]}
        </Typography.Text>
      </View>
    );
  },
);
